export default "__VITE_ASSET__a55dbfad__"